import React from 'react';
import { Helmet } from 'react-helmet';

const GoogleAnalytics = () => (
  <Helmet>
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-147L8CDHS0"></script>
    <script>
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-147L8CDHS0', {
          anonymize_ip: true,
          allow_ad_personalization_signals: false
        });
      `}
    </script>
  </Helmet>
);

export default GoogleAnalytics;